export const ENABLE_API_MOCK = import.meta.env.VITE_ENABLE_API_MOCK;
export const SSO_IDENTITY_PROVIDER = import.meta.env.VITE_SSO_IDENTITY_PROVIDER;

export const APP_ENV = {
  PROD: 'prod',
  QA: 'qa',
  DEV: 'dev',
  STAGE: 'stage',
  E2E: 'e2e',
  LOCAL: 'local',
} as const;

export type AppEnv = (typeof APP_ENV)[keyof typeof APP_ENV];

const providersArray = JSON.parse(SSO_IDENTITY_PROVIDER ?? '{}');

export const SSO_IDENTITY_PROVIDER_SIGMA = providersArray[0];
export const SSO_IDENTITY_PROVIDER_TMDX = providersArray[1];
export const SSO_CONFIG_JSON = import.meta.env.VITE_SSO_CONFIG_JSON;

/**
 * URL of the active-region document published by the cognito-check-custom-auth
 * lambda (e.g. https://config.<env-domain>/auth/active-region.json). Unset disables
 * Cognito region failover on the client — see libs/shared/core/src/auth.
 */
export const AUTH_REGION_URL = import.meta.env.VITE_AUTH_REGION_URL;
export const HERE_MAPS_API_KEY = import.meta.env.VITE_HERE_MAPS_API_KEY;

const MAP_STYLE = 'logistics.day';
export const HERE_MAPS_TILES_URL = `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png?apiKey=${HERE_MAPS_API_KEY}&style=${MAP_STYLE}`;

export const ENV_MODE = import.meta.env.MODE;

/**
 * True whenever the app is served by the Vite dev server, false in any build.
 *
 * Derived from `import.meta.env.DEV` rather than `MODE === 'development'` so that it survives a
 * named mode - `--mode nop-access`, or the `local-platform-*` modes used to run against
 * OCS-LocalStack. Comparing MODE silently disabled the devtools this gates for every such run.
 */
export const IS_DEV_MODE = import.meta.env.DEV;
export const IS_PROD = !Object.values(APP_ENV)
  .filter((env) => env !== APP_ENV.PROD)
  .some((env) => import.meta.env.VITE_API_ORIGIN?.includes(env));
export const IS_DEV = import.meta.env.VITE_API_ORIGIN?.includes(APP_ENV.DEV);
export const IS_QA = import.meta.env.VITE_API_ORIGIN?.includes(APP_ENV.QA);
export const IS_LOCAL = import.meta.env.VITE_API_ORIGIN?.includes(APP_ENV.LOCAL);

// Local envs
export const USE_DEVTOOLS = import.meta.env.VITE_USE_DEVTOOLS === 'true';

export const STREAM_API_KEY = import.meta.env.VITE_STREAM_API_KEY;
export const WS_ORIGIN_URL = import.meta.env.VITE_WS_ORIGIN;

export const INTERCOM_APP_ID = import.meta.env.VITE_INTERCOM_APP_ID;

export const DISTANCE_API_ORIGIN = import.meta.env.VITE_DISTANCE_API_ORIGIN;

export const APP_NAME = import.meta.env.VITE_APP_NAME;

/**
 * First day (`yyyy-MM-dd`) of the Clinical Specialists 28-day period grid: CS schedules on/after it are
 * periods, before it calendar months. A one-time, per-environment migration date - unset keeps CS on months.
 */
export const CS_PERIODS_START_DATE = import.meta.env.VITE_CS_PERIODS_START_DATE;
